import script from "./textarea.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./textarea.vue?vue&type=script&setup=true&lang=js"
export * from "./textarea.vue.js?vue&type=script&setup=true&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./textarea.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__